// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3KDwe","imageUploader":"EGiftCard_imageUploader__1grQm"};